import React from 'react';
import { connect } from 'react-redux';
import RefreshActionMenu from '@/components/ribbon-actions/RefreshActionMenu';
import { refreshVocabularies } from '../actions';

const VocabulariesActions = ({
  category,
  readStatus,
  allowRefresh,
  refresh,
}) => (
  <>
    {allowRefresh && (<RefreshActionMenu onClick={() => refresh(category, 1)} readStatus={readStatus} />)}
  </>
);

export const mapStateToProps = ({
  auth: { role: { permissions: { vocabularies: { update } } } },
  vocabularies: { vocabularies },
}, { category }) => ({ allowRefresh: update, readStatus: vocabularies[category].readStatus });

const mapDispatchToProps = {
  refresh: refreshVocabularies,
};

export default connect(mapStateToProps, mapDispatchToProps)(VocabulariesActions);
